export const startsWithNoSpace = /^(?!\s)[a-zA-Z0-9_\s-]*$/;
export const noSpaces = /\s/g;
export const hoursColonMinutesFormat = /^\d*(:\d{0,2})?$/; // 00:00 || 000:00 || 0000000:00
